/* tslint:disable */
/* eslint-disable */
/**
 * Project Freelancer API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
import type { Currency } from './';
import {
    CurrencyFromJSON,
    CurrencyFromJSONTyped,
    CurrencyToJSON,
} from './';
import type { InvoicingModeType } from './';
import {
    InvoicingModeTypeFromJSON,
    InvoicingModeTypeFromJSONTyped,
    InvoicingModeTypeToJSON,
} from './';
import type { ProjectType } from './';
import {
    ProjectTypeFromJSON,
    ProjectTypeFromJSONTyped,
    ProjectTypeToJSON,
} from './';
import type { QuoteSource } from './';
import {
    QuoteSourceFromJSON,
    QuoteSourceFromJSONTyped,
    QuoteSourceToJSON,
} from './';

/**
 * 
 * @export
 * @interface ContractResource
 */
export interface ContractResource {
    /**
     * 
     * @type {Date}
     * @memberof ContractResource
     */
    startDate: Date;
    /**
     * 
     * @type {Date}
     * @memberof ContractResource
     */
    endDate?: Date;
    /**
     * 
     * @type {ProjectType}
     * @memberof ContractResource
     */
    type: ProjectType;
    /**
     * 
     * @type {string}
     * @memberof ContractResource
     */
    subject: string;
    /**
     * 
     * @type {string}
     * @memberof ContractResource
     */
    description?: string;
    /**
     * 
     * @type {string}
     * @memberof ContractResource
     */
    descriptionFormat?: ContractResourceDescriptionFormatEnum;
    /**
     * 
     * @type {Currency}
     * @memberof ContractResource
     */
    currency: Currency;
    /**
     * 
     * @type {string}
     * @memberof ContractResource
     */
    pdfUrl: string;
    /**
     * 
     * @type {string}
     * @memberof ContractResource
     */
    maltBillingEntityName: string;
    /**
     * 
     * @type {number}
     * @memberof ContractResource
     */
    paymentDelay: number;
    /**
     * 
     * @type {InvoicingModeType}
     * @memberof ContractResource
     */
    invoicingModeType: InvoicingModeType;
    /**
     * 
     * @type {QuoteSource}
     * @memberof ContractResource
     */
    quoteSource: QuoteSource;
    /**
     * 
     * @type {string}
     * @memberof ContractResource
     */
    clientPaymentMode: ContractResourceClientPaymentModeEnum;
}


/**
 * @export
 */
export const ContractResourceDescriptionFormatEnum = {
    Simple: 'SIMPLE',
    Markdown: 'MARKDOWN'
} as const;
export type ContractResourceDescriptionFormatEnum = typeof ContractResourceDescriptionFormatEnum[keyof typeof ContractResourceDescriptionFormatEnum];

/**
 * @export
 */
export const ContractResourceClientPaymentModeEnum = {
    Prepayment: 'PREPAYMENT',
    PaymentByInvoice: 'PAYMENT_BY_INVOICE'
} as const;
export type ContractResourceClientPaymentModeEnum = typeof ContractResourceClientPaymentModeEnum[keyof typeof ContractResourceClientPaymentModeEnum];


/**
 * Check if a given object implements the ContractResource interface.
 */
export function instanceOfContractResource(value: object): value is ContractResource {
    if (!('startDate' in value) || value['startDate'] === undefined) return false;
    if (!('type' in value) || value['type'] === undefined) return false;
    if (!('subject' in value) || value['subject'] === undefined) return false;
    if (!('currency' in value) || value['currency'] === undefined) return false;
    if (!('pdfUrl' in value) || value['pdfUrl'] === undefined) return false;
    if (!('maltBillingEntityName' in value) || value['maltBillingEntityName'] === undefined) return false;
    if (!('paymentDelay' in value) || value['paymentDelay'] === undefined) return false;
    if (!('invoicingModeType' in value) || value['invoicingModeType'] === undefined) return false;
    if (!('quoteSource' in value) || value['quoteSource'] === undefined) return false;
    if (!('clientPaymentMode' in value) || value['clientPaymentMode'] === undefined) return false;
    return true;
}

export function ContractResourceFromJSON(json: any): ContractResource {
    return ContractResourceFromJSONTyped(json, false);
}

export function ContractResourceFromJSONTyped(json: any, ignoreDiscriminator: boolean): ContractResource {
    if (json == null) {
        return json;
    }
    return {
        
        'startDate': (new Date(json['startDate'])),
        'endDate': json['endDate'] == null ? undefined : (new Date(json['endDate'])),
        'type': ProjectTypeFromJSON(json['type']),
        'subject': json['subject'],
        'description': json['description'] == null ? undefined : json['description'],
        'descriptionFormat': json['descriptionFormat'] == null ? undefined : json['descriptionFormat'],
        'currency': CurrencyFromJSON(json['currency']),
        'pdfUrl': json['pdfUrl'],
        'maltBillingEntityName': json['maltBillingEntityName'],
        'paymentDelay': json['paymentDelay'],
        'invoicingModeType': InvoicingModeTypeFromJSON(json['invoicingModeType']),
        'quoteSource': QuoteSourceFromJSON(json['quoteSource']),
        'clientPaymentMode': json['clientPaymentMode'],
    };
}

export function ContractResourceToJSON(value?: ContractResource | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'startDate': ((value['startDate']).toISOString().substring(0,10)),
        'endDate': value['endDate'] == null ? undefined : ((value['endDate']).toISOString().substring(0,10)),
        'type': ProjectTypeToJSON(value['type']),
        'subject': value['subject'],
        'description': value['description'],
        'descriptionFormat': value['descriptionFormat'],
        'currency': CurrencyToJSON(value['currency']),
        'pdfUrl': value['pdfUrl'],
        'maltBillingEntityName': value['maltBillingEntityName'],
        'paymentDelay': value['paymentDelay'],
        'invoicingModeType': InvoicingModeTypeToJSON(value['invoicingModeType']),
        'quoteSource': QuoteSourceToJSON(value['quoteSource']),
        'clientPaymentMode': value['clientPaymentMode'],
    };
}

